<template>
  <transition name="fade">
    <div v-if="show" class="account-expire-notice">
      <div class="notice-content">
        {{ noticeText }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AccountExpireNotice",
  data() {
    return {
      show: false,
      noticeText: "",
      timer: null,
    };
  },
  mounted() {
    // 监听全局事件
    this.$root.$on("show-expire-notice", this.handleShowNotice);
  },
  beforeDestroy() {
    // 清理事件监听和定时器
    this.$root.$off("show-expire-notice", this.handleShowNotice);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    handleShowNotice(data) {
      this.noticeText = data.text;
      this.show = true;

      // 5秒后自动隐藏
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>

<style scoped lang="scss">
.account-expire-notice {
  position: fixed;
  top: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  pointer-events: none;

  .notice-content {
    // background-color: rgba(0, 0, 0, 0.75);
    color: red;
    // padding: 20px 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    text-align: center;
    min-width: 400px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

